export default "__VITE_ASSET__CIBDawOA__"